<template>
  <v-text-field
    v-if="allowedValues.range"
    type="number" step="1" hint="hint" persistent-hint persistent-placeholder placeholder="0"
    :min="allowedValues.range.min"
    :max="maxConstrained"
    :disabled="allowedValues.range.min > max"
    :rules="[
      v => !!v || 'Invalid value',
      v => (parseInt(v) >= allowedValues.range.min && parseInt(v) <= maxConstrained) || 'Invalid value'
    ]"
    :value="String(value)"
    @input="x => $emit('input', x ? parseInt(x) : x)"
    @keydown="x => { if (/[\.,]/.test(x.key)) x.preventDefault(); }"
  >
    <template v-slot:prepend-inner>
      <currency class="mt-1" :code="cur" />
    </template>
    <template v-slot:message>
      <template v-if="allowedValues.range.min > max">
        Max overall gift card value reached
      </template>
      <template v-else>
        <currency :code="cur" />{{allowedValues.range.min}} – <currency :code="cur" />{{maxConstrained}}
      </template>
    </template>
  </v-text-field>
  <div v-else-if="allowed.length == 0" class="text--label-active error--text">
    Max overall gift card value reached
  </div>
  <v-input v-else :error="!allowed.includes(value)">
    <v-row>
      <v-col v-for="v in allowed" :key="v" cols="4">
        <v-btn style="width: 100%;" :input-value="value == v" @click="$emit('input', v)">
          <currency :code="cur" />{{v}}
        </v-btn>
      </v-col>
    </v-row>
  </v-input>
</template>


<script>
import Currency from '@/components/Currency.vue';

export default {
  name: 'giftcard-amount',

  components: { Currency },

  props: [ 'allowed-values', 'cur', 'value', 'max' ],

  computed: {
    maxConstrained() {
      return Math.min(this.allowedValues.range.max, this.max);
    },

    allowed() {
      return this.allowedValues.fixed.filter(x => x <= this.max);
    }
  }
}
</script>
